<template>
    <div v-if="item" class="media-info">
        <h4 class="header-title">{{ itemTypeTitle }} info</h4>
         <table class="table-condensed table-hover table-striped review-info-table w-100">
            <tbody>
            <tr>
                <th scope="row">Created</th>
                <td>
                    {{ item.createdAt }}
                </td>
            </tr>
             <tr>
                <th scope="row">Last updated</th>
                <td>
                    {{ item.lastUpdated }}
                </td>
            </tr>
            <tr v-if="item.hasUser || item.hasFileUser">
                <th scope="row">Uploaded by</th>
                <td>
                    {{ item.uploadedBy }}
                </td>
            </tr>
            <tr>
                <th scope="row">Title</th>
                <td>{{ item.title }}</td>
            </tr>
            <tr v-if="item.description">
                <th scope="row">Description</th>
                <td v-html="mediaDescription"></td>
            </tr>
            <tr v-if="item.hasDevice">
                <th scope="row">Capture device</th>
                <td>{{ item.getDevice }} </td>
            </tr>
            <tr v-if="item.hasModel">
                <th scope="row">Model version</th>
                <td>{{ item.getModel }} </td>
            </tr>
            <tr v-if="item.hasProgram">
                <th scope="row">Program version</th>
                <td>{{ item.getProgram }} </td>
            </tr>
            <tr v-if="item.isVideo && item.hasVimeo">
                <th scope="row">Vimeo URL</th>
                <td v-html="vimeoLink"></td>
            </tr>
            <tr v-if="item.isImage && item.hasOriginalSize">
                <th scope="row">Size</th>
                <td>{{ formatBytes(item.original.size, 2) }}</td>
            </tr>
            <tr v-else-if="item.hasSize">
                <th scope="row">Size</th>
                <td>{{ formatBytes(item.filesize, 2) }}</td>
            </tr>
            <tr v-if="item.hasDuration">
                <th scope="row">Duration</th>
                <td>{{ item.duration }}</td>
            </tr>
            <tr v-if="item.hasOriginalDimensions">
                <th scope="row">Dimensions</th>
                <td>{{ item.originalDimensions.width }}x{{ item.originalDimensions.height }}</td>
            </tr>
            <tr v-else-if="item.hasDimensions">
                <th scope="row">Dimensions</th>
                <td>{{ item.dimensions.width }}x{{ item.dimensions.height }}</td>
            </tr>
            <tr v-if="item.hasMimeType">
                <th scope="row">Type</th>
                <td>{{ item.mimeType }}</td>
            </tr>
            <tr v-if="item.hasLocation">
                <th scope="row">Location</th>
                <td>{{ item.getFileMeta('location') }}</td>
            </tr>
            <tr v-if="item.hasCameraPosition">
                <th scope="row">Camera</th>
                <td>
                    <div v-if="has(item.cameraPosition, 'ProjectX')"><span>ProjectX:</span> {{ item.cameraPosition.ProjectX }}</div>
                    <div v-if="has(item.cameraPosition, 'Height')"><span>Height:</span> {{ item.cameraPosition.Height }}</div>
                    <div v-if="has(item.cameraPosition, 'ProjectY')"><span>ProjectY:</span> {{ item.cameraPosition.ProjectY }}</div>
                    <div v-if="has(item.cameraPosition, 'Latitude')"><span>Latitude:</span> {{ item.cameraPosition.Latitude }}</div>
                    <div v-if="has(item.cameraPosition, 'Longitude')"><span>Longitude:</span> {{ item.cameraPosition.Longitude }}</div>
                </td>
            </tr>
            <tr v-if="item.hasTargetPosition">
                <th scope="row">Target</th>
                <td>
                    <div v-if="has(item.targetPosition, 'ProjectX')"><span>ProjectX:</span> {{ item.targetPosition.ProjectX }}</div>
                    <div v-if="has(item.targetPosition, 'Height')"><span>Height:</span> {{ item.targetPosition.Height }}</div>
                    <div v-if="has(item.targetPosition, 'ProjectY')"><span>ProjectY:</span> {{ item.targetPosition.ProjectY }}</div>
                    <div v-if="has(item.targetPosition, 'Latitude')"><span>Latitude:</span> {{ item.targetPosition.Latitude }}</div>
                    <div v-if="has(item.targetPosition, 'Longitude')"><span>Longitude:</span> {{ item.targetPosition.Longitude }}</div>
                </td>
            </tr>
            <tr v-if="item.hasFOV">
                <th scope="row">Properties</th>
                <td>
                    <div><span>FOV:</span> {{ item.getFileMeta('fov') }}&deg;</div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { startCase, has } from 'lodash';
import { formatBytes, formatDateTime } from 'ca-js-helper';
import linkifyHtml from 'linkifyjs/html';

export default {
    name: 'MediaInfo',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    filters: {
        formatDateTime,
    },
    computed: {
        itemTypeTitle() {
            let title = startCase(this.item.type);
            if (this.item.type === 'gallery') title = 'Collection';
            return title;
        },
        mediaDescription() {
            return linkifyHtml(this.item.description, {
                defaultProtocol: 'https',
            });
        },
        vimeoLink() {
            return `https://vimeo.com/${this.item.vimeoId}`;
        },
    },
    methods: {
        formatBytes,
        startCase,
        has,
    }
}
</script>
